import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";

function Activation_History() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // let user = "";
  const [isLoading, setisLoading] = useState(false);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [allMember, setAllMember] = useState("");
  const [fromRegdate, setfromRegdate] = useState("");
  const [toRegdate, settoRegdate] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/AllMemberList",
        {
          loginid: userId,
          SearchTerm: search,
          fromdate: fromRegdate,
          todate: toRegdate,
          PageIndex: "1",
          PageSize: "10000",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //console.log("memberlist-->", responceRight.data.data);
      // setStakingdata(responceRight?.data?.data.records[0])
      responceRight = responceRight.data.data[0];
      setAllMember(responceRight);
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          // id: `${item?.uid} `,
          login: (
            <>
              <a
                href={`https://www.donaltern.com/AdminLogin?user_id=${item.uid}&enpass=${item?.password}`}
                target="_blank"
                className="btn btn-lg btn-primary"
              >
                Login
              </a>
            </>
          ),
          user_id: `${item?.uid} `,
          sid: `${item?.sid} `,
          Waddress: `${item?.trans_password} `,
          lipa: item?.ipaddress,
          RegDate: `${item?.date}`,
          package: `${item?.packageamount}`,
          top_update1: item?.top_update1,
          edate: `${item?.edate} `,
          Topupstatus: `${item?.top_up === 1 ? "Active" : "InActive"}`,
          BotTopupstatus: `${item?.Bottop_up === 1 ? "Active" : "InActive"}`,
          status: item?.blockstatus,
          f_name: item?.f_name,
          email: item?.email,
          mobile: item?.mobile,
          staking: (
            <>
              <button
                className={`${
                  item?.blockstatus === "Active" ? "btn-danger" : "btn-primary"
                } btn`}
                onClick={() => Status_active(item?.uid, item?.blockstatus)}
              >
                {item?.blockstatus === "Active" ? "Block" : "Active"}
              </button>
            </>
          ),
          Withstatus: `${item?.withdrawl_status == 1 ? "Active" : "Block"}`,
          withstaking: (
            <>
              <button
                className={`${
                  item?.withdrawl_status === 1 ? "btn-danger" : "btn-primary"
                } btn`}
                onClick={() =>
                  Status_active_withdraw(item?.uid, item?.withdrawl_status)
                }
              >
                {item?.withdrawl_status === 1 ? "Block" : "Active"}
              </button>
            </>
          ),
          edit: (
            <>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() =>
                  navigate(`/Edit_Details?userId=${item?.user_id}`)
                }
              >
                Edit
              </button>
            </>
          ),
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const Status_active = async (id, blockstatus) => {
    try {
      console.log("statevalue", blockstatus);
      let status_value = blockstatus;
      let status = 1;

      if (status_value == "Active") {
        status = 0;
      } else {
        status = 1;
      }
      // console.log("id=>", id);
      // console.log("status=>", status);
      let res = await API?.post(
        "/Changestatus",

        {
          loginid: userId,
          uid: id,
          status: status,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Update Successfully ..");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const Status_active_withdraw = async (id, withdrawl_status) => {
    try {
      console.log("statevalue", withdrawl_status);
      let status_value = withdrawl_status;
      let status = 1;

      if (status_value == 1) {
        status = 0;
      } else {
        status = 1;
      }
      // console.log("id=>", id);
      // console.log("status=>", status);
      let res = await API?.post(
        "/ChangeWtihdrawalStatus",

        {
          loginid: userId,
          uid: id,
          status: status,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Update Successfully ..");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/AllMemberList",
        {
          loginid: userId,
          SearchTerm: search,
          fromdate: fromDate,
          todate: toDate,
          PageIndex: "1",
          PageSize: "10000",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("memberlist-->", responceRight.data.data);
      responceRight = responceRight.data.data[0];
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          user_id: `${item?.uid} `,
          sid: `${item?.sid} `,
          email: item?.email,
          mobile: item?.mobile,
          RegDate: `${item?.date}`,
          package: `${item?.packageamount}`,
          top_update1: item?.top_update1,
          edate: `${item?.edate}`,
          Topupstatus: `${item?.top_up === 1 ? "Active" : "InActive"}`,
          status: item?.blockstatus,
          // Withstatus: `${item?.withdrawl_status == 1 ? "Active" : "Block"}`,
        });
      });

      const fileName = "AllmembersRecord";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Login", accessor: "login" },
      { Header: "User Id", accessor: "user_id" },
      { Header: "Sponsor Id", accessor: "sid" },
      { Header: "Name", accessor: "f_name" },
      { Header: "Email", accessor: "email" },
      { Header: "Mobile", accessor: "mobile" },
      //{ Header: "Wallet Address", accessor: "Waddress" },
      //{ Header: "Login IP Address", accessor: "lipa" },
      { Header: "Reg. Date", accessor: "RegDate" },
      // { Header: "Bot Status", accessor: "BotTopupstatus" },
      { Header: "Trading Status", accessor: "Topupstatus" },
      { Header: "Activation Amount", accessor: "package" },
      { Header: "Activation Date", accessor: "top_update1" },
      { Header: "Block Status", accessor: "status" },
      { Header: "Action", accessor: "staking" },
      //{ Header: "Withdrawl Status", accessor: "Withstatus" },
      //{ Header: "Withdrawl Action", accessor: "withstaking" },
      { Header: "Edit", accessor: "edit" },
    ],
  });

  // if (isLoading) return <Spinner />;

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Member Details</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-lg-2 col-xl-2 col-md-3">
                      <label>User Id</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        id="uid"
                        onChange={(e) => setSearch(e.target.value)}
                        name="uid"
                        placeholder="Search By User Id or Name or Email"
                        type="text"
                        value={search}
                      />
                    </div>
                    <div class="col-lg-2 col-xl-2 col-md-3">
                      <label>Registration From</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setfromRegdate(e.target.value)}
                        value={fromRegdate}
                        id="todate"
                        name="todate"
                        type="date"
                      />
                    </div>
                    <div class="col-lg-2 col-xl-2 col-md-3">
                      <label>Registration To</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        value={toRegdate}
                        onChange={(e) => settoRegdate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>

                    <div class="col-lg-1 col-xl-1 col-md-1">
                      <br />
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API()}
                        class="btn btn-lg btn-primary"
                        value="Search"
                      />
                    </div>
                    <div class="col-lg-2 col-xl-2 col-md-3">
                      <br />
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API_Export()}
                        class="btn btn-lg btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <h4>
                      <span></span>
                    </h4>
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div>
                        <div className="col-md-12">
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />

                          <Table_Buttons
                            indexOfFirstPage={indexOfFirstPage}
                            indexOfLastPost={indexOfLastPost}
                            setcurrentPage={setcurrentPage}
                            currentPage={currentPage}
                            totalData={leftreferralApi.length}
                            listPerpage={listPerpage}
                            handleRowsPerPageChange={setlistPerpage}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Activation_History;
